import { SelectOptionType } from '@octano/global-ui';
import { Base } from '../types/GenericFormTypes';

export const mapNameAndIdToLabelAndValue = (
  resource: Base,
): SelectOptionType => ({
  label: resource.name,
  value: resource.id!,
});
